// Copyright (c) 2015, Neo Pacific Pvt. Ltd. and Contributors
// MIT License. See license.txt

// provide a namespace
if (!window.nxf) window.nxf = {};

nxf.provide = function (namespace) {
	// docs: create a namespace //
	var nsl = namespace.split(".");
	var parent = window;
	for (var i = 0; i < nsl.length; i++) {
		var n = nsl[i];
		if (!parent[n]) {
			parent[n] = {};
		}
		parent = parent[n];
	}
	return parent;
};

nxf.provide("locals");
nxf.provide("nxf.flags");
nxf.provide("nxf.settings");
nxf.provide("nxf.utils");
nxf.provide("nxf.ui.form");
nxf.provide("nxf.modules");
nxf.provide("nxf.templates");
nxf.provide("nxf.test_data");
nxf.provide("nxf.utils");
nxf.provide("nxf.model");
nxf.provide("nxf.user");
nxf.provide("nxf.session");
nxf.provide("nxf._messages");
nxf.provide("locals.DocType");

// for listviews
nxf.provide("nxf.listview_settings");
nxf.provide("nxf.tour");
nxf.provide("nxf.listview_parent_route");

// constants
window.NEWLINE = "\n";
window.TAB = 9;
window.UP_ARROW = 38;
window.DOWN_ARROW = 40;

// proxy for user globals defined in desk.js

// API globals
window.cur_frm = null;
